<template>
  <div class="tracking-container">
    <div class="tracking-box-scroll">

      <div class="background-columns">
        <div class="column odd"></div>
        <div class="column"></div>
        <div class="column odd"></div>
        <div class="column"></div>
        <div class="column odd"></div>
        <div class="column"></div>
      </div>
      <div class="columns-roles-header">
        <div class="column-roles-header-text">Transit.</div>
        <div class="column-roles-header-text">Carg</div>
        <div class="column-roles-header-text">Transp</div>
        <div class="column-roles-header-text">Naviera</div>
        <div class="column-roles-header-text">Term</div>
        <div class="column-roles-header-text">Valid</div>
      </div>

      <TrackingStage
          v-for="stage in grid_content"
          v-bind:key="stage.id"
          v-bind:stage="stage.id"
          v-bind:title="stage.title"
          v-bind:cells="stage.cells"
      ></TrackingStage>

    </div>
    <div class="tracking-info"
      v-bind:class="{ 'completed': tracking_info_status=='Completado', 
                      'pending': tracking_info_status=='Pendiente', 
                      'disabled': tracking_info_status=='Requiere acciones anteriores' }">
      <div class="tracking-info-name">{{ tracking_info_name }}</div>  
      <div class="tracking-info-bottom-row"> 
        <div class="tracking-info-status">{{ tracking_info_status }}</div>
        <div class="tracking-info-modified">{{ tracking_info_modified }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import TrackingStage from '@/components/containerViews/containerTrackingComponents/TrackingStage'
import { mapGetters } from 'vuex'
import { updateContainerActions } from '@/services/helper'
import { infiniteUpdateStatus } from '@/services/automatedActions'

export default {
  name: 'ContainerTracking',
  components: {
    TrackingStage
  },
  computed: {
    ...mapGetters("container",{
      container_id: 'container_id',
      container_status: 'container_status',
      action_list: 'action_list'
    }),
  },
  created() {
    this.UpdateGrid()
  },
  mounted() {
    this.UpdateTracking()
  },
  watch: {
    'action_list': function () {
        this.UpdateGrid()
    },
  },
  data(){
    return {
        tracking_info_name: '',
        tracking_info_status: '',
        tracking_info_modified: '',
        grid_content: {
          // Row 1
          stage1: {
            id: '1',
            title: 'Apertura de expediente',
            cells: {
              pos01: { id: "blank001", icon: "", status: "-" },
              pos02: {
                id: "001",
                icon: "new",
                status: "",
                text: 'Reserv',
                name: '',
                modified: '',
                line_vertical: '1',
                line_horizontal: '-1'
              },            
              pos03: { id: "blank003", icon: "", status: "-" },
              pos04: { id: "blank004", icon: "", status: "-" },
              pos05: { id: "blank005", icon: "", status: "-" },
              pos06: { id: "blank006", icon: "", status: "-" },
              // Row 2
              pos07: {
                id: "002",
                icon: "new",
                status: "",
                text: 'Exped',
                name: '',
                modified: '',
                line_horizontal: '3',
                line_vertical: ''
              },
              pos08: { id: "blank008", icon: "", status: "-" },
              pos09: { id: "blank009", icon: "", status: "-" },
              pos10: {
                id: "003",
                icon: "upload",
                status: "",
                text: 'Viaje',
                name: '',
                modified: '',
                line_horizontal: '',
                line_vertical: '1'
              },             
              pos11: { id: "blank011", icon: "", status: "-" },
              pos12: { id: "blank012", icon: "", status: "-" }
            }
          },
          stage2: {
            id: '2',
            title: 'Recogida de contenedor vacío',
            cells: {
              // Row 3
              pos13: {
                id: "004",
                icon: "truck",
                status: "",
                text: 'Aviso',
                name: '',
                modified: '',
                line_vertical: '',
                line_horizontal: '2'
              },            
              pos14: { id: "blank014", icon: "", status: "-" },
              pos15: {
                id: "005",
                icon: "truck",
                status: "",
                text: 'O. Rec',
                name: '',
                modified: '',
                line_vertical: '1',
                line_horizontal: ''
              },
              pos16: { id: "blank016", icon: "", status: "-" },
              pos17: { id: "blank017", icon: "", status: "-" },
              pos18: { id: "blank018", icon: "", status: "-" },
              // Row 4 
              pos19: { id: "blank019", icon: "", status: "-" },
              pos20: { id: "blank020", icon: "", status: "-" },
              pos21: {
                id: "006",
                icon: "truck",
                status: "",
                text: 'Recog',
                name: '',
                modified: '',
                line_vertical: '1',
                line_horizontal: ''
              },
              pos22: { id: "blank022", icon: "", status: "-" },
              pos23: { id: "blank023", icon: "", status: "-" },
              pos24: { id: "blank024", icon: "", status: "-" }
            }
          },
          stage3: {
            id: '3',
            title: 'Entrega de contenedor lleno',
            cells: {
              // Row 5
              pos25: { id: "blank025", icon: "", status: "-" },
              pos26: { id: "blank026", icon: "", status: "-" },
              pos27: {
                id: "008",
                icon: "truck",
                status: "",
                text: 'Preci.',
                name: '',
                modified: '',
                line_vertical: '1',
                line_horizontal: '-1'
              },
              pos28: { id: "blank028", icon: "", status: "-" },
              pos29: { id: "blank029", icon: "", status: "-" },
              pos30: { id: "blank030", icon: "", status: "-" },
              // Row 6
              pos31: { id: "blank031", icon: "", status: "-" },
              pos32: {
                id: "009",
                icon: "new",
                status: "",
                text: 'Docu.',
                name: '',
                modified: '',
                line_vertical: '1',
                line_horizontal: '-1'
              },
              pos33: { id: "blank033", icon: "", status: "-" },
              pos34: { id: "blank034", icon: "", status: "-" },
              pos35: { id: "blank035", icon: "", status: "-" },
              pos36: { id: "blank036", icon: "", status: "-" },
              // Row 7
              pos37: {
                id: "016",
                icon: "new",
                status: "",
                text: 'DUA',
                name: '',
                modified: '',
                line_vertical: '',
                line_horizontal: '5'
              },
              pos38: { id: "blank038", icon: "", status: "-" },
              pos39: { id: "blank039", icon: "", status: "-" },
              pos40: { id: "blank040", icon: "", status: "-" },
              pos41: { id: "blank041", icon: "", status: "-" },
              pos42: {
                id: "017",
                icon: "new",
                status: "",
                text: 'A.Lev',
                name: '',
                modified: '',
                line_vertical: '1',
                line_horizontal: ''
              }
            }
          },
          stage4: {
            id: '4',
            title: 'Carga del buque',
            cells: {
              // Row 8
              pos43: { id: "blank043", icon: "", status: "-" },
              pos44: { id: "blank044", icon: "", status: "-" },
              pos45: { id: "blank045", icon: "", status: "-" },
              pos46: {
                id: "018",
                icon: "boat",
                status: "",
                text: 'Cargado',
                name: '',
                modified: '',
                line_vertical: '1',
                line_horizontal: '-3'
              },
              pos47: { id: "blank047", icon: "", status: "-" },
              pos48: { id: "blank048", icon: "", status: "-" },
              // Row 9
              pos49: {
                id: "019",
                icon: "new",
                status: "",
                text: 'B/L',
                name: '',
                modified: '',
                line_vertical: '',
                line_horizontal: ''
              },
              pos50: { id: "blank050", icon: "", status: "-" },
              pos51: { id: "blank051", icon: "", status: "-" },
              pos52: { id: "blank052", icon: "", status: "-" },
              pos53: { id: "blank053", icon: "", status: "-" },
              pos54: { id: "blank054", icon: "", status: "-" }
            }
          }
        }
    }
  },
  methods: {
    UpdateTracking: function () {
      var internalId = this.container_id
      var timeOutHandler
      //infiniteUpdateStatus(this.container_id)  
      window.clearTimeout(timeOutHandler);
      console.log(this.$store.getters.container_view_selected_tab)
      if(this.$store.getters.container_view_selected_tab != 'tracking') {       
          return
      }
      this.UpdateGrid()
      var Update = this.UpdateTracking
      //console.log("Updating " + internalId + "...")
      updateContainerActions(internalId)
      timeOutHandler = window.setTimeout(function(){
        Update (internalId)
      }, 5000);
    },
    UpdateGrid: function () {
      for(var stageItem in this.action_list) {
        for(var actionItem in this.action_list[stageItem].action_list) {
          for(var gridStageItem in this.grid_content) {
            for(var gridActionItem in this.grid_content[gridStageItem].cells) {
              if(this.action_list[stageItem].action_list[actionItem].id == this.grid_content[gridStageItem].cells[gridActionItem].id){
                this.grid_content[gridStageItem].cells[gridActionItem].name = this.action_list[stageItem].action_list[actionItem].name
                this.grid_content[gridStageItem].cells[gridActionItem].status = this.action_list[stageItem].action_list[actionItem].status
                this.grid_content[gridStageItem].cells[gridActionItem].modified = this.action_list[stageItem].action_list[actionItem].modified
              }
            }
          }
        }
      }
      console.log("Entra en updateGrid")
      this.$forceUpdate();
    },
    DisplayCellInfo: function (name, status, modified) {
      this.tracking_info_name = name
      if(status == "completed"){
        this.tracking_info_status = "Completado"
      } 
      else if(status == "pending"){
        this.tracking_info_status = "Pendiente"
      }
      else {
        this.tracking_info_status = "Requiere acciones anteriores"
      }   
      this.tracking_info_modified = modified
    }
  }
}
</script>

<style lang= "scss" scoped>
    .tracking-container {
      position: absolute;
      width:100%;
      bottom: 30px;
      top:151px;
      display: flex;
      flex-direction: column;
    }
    .tracking-box-scroll {
      overflow: scroll;
      margin: 0;
      flex: 1;
    }
    .background-columns {
      display: flex;
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: -20;
    }
    .column {
      flex: 1;
      padding-top: 8px;
      display: flex;
      justify-content: center;
      color: #555555;
    }
    .column.odd {
      background-color: #EFEFEF;
    }
    .columns-roles-header {
      position: absolute;
      height: 30px;
      width: 100%;
      z-index: 10;
      background-color: rgba(255,255,255,0.9);
      box-shadow: 0px 3px 6px rgba(0,0,0,0.3);
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .column-roles-header-text {
      flex: 1 1 0px;
      display: flex;
      justify-content: center;
      font-size: 0.8em;
    }
    .tracking-info {
      height: 80px;
      background-color: rgba(255,255,255,0.8);
      box-shadow: 0px -3px 6px rgba(0,0,0,0.3);
      display: flex;
      flex-direction: column;
      padding: 12px;
    }
    .tracking-info-name {
      font-weight: 400;
      color: #555555;
    }
    .tracking-info-bottom-row {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .tracking-info-status {
      flex:1;
    }
    .tracking-info-modified {
      color: #777777;
    }
    .completed {
      color: #32AC91;
    }
    .pending {
      color: #00B1FF;
    }
    .disabled {
      color: #C0C0C0;
    }
</style>
